import { AppUpdate } from '@/types/updates';

export const update_2026_02: AppUpdate = {
  id: 'performance-2026-02',
  slug: 'web-worker-physics-migration',
  title: 'Optimization: 120FPS Physics with Web Workers',
  description: 'In late March, we completely re-engineered the engine\'s heart. By moving physics calculations to a dedicated background thread, we unlocked unprecedented performance.',
  date: 'March 28, 2026',
  timestamp: 1774886400,
  category: 'IMPROVEMENT',
  version: '0.8.5',
  readTime: '4 min read',
  author: {
    name: 'FCG Dev',
    role: 'Lead Architect'
  },
  content: [
    {
      type: 'heading',
      content: 'Breaking the Main Thread Barrier'
    },
    {
      type: 'text',
      content: 'As our simulations became more complex with Multi-Sim mode, we hit a wall. In standard web development, everything usually runs on a single "main thread." If the physics engine takes too long to calculate a collision, the UI lags. In late March, we fixed this once and for all.'
    },
    {
      type: 'heading',
      content: 'How Web Workers Work'
    },
    {
      type: 'text',
      content: 'Imagine your computer has multiple brains. Previously, we were only using one. We migrated the entire physics system to a "Web Worker"—a separate process that runs in the background. Now, while your screen renders beautiful 4K visuals, a hidden "math brain" is crunching thousands of collision vectors every millisecond without slowing down the interface.'
    },
    {
      type: 'list',
      content: [
        'Zero-Lag UI: Sliders and menus now feel instantaneous, even if there are 500+ balls on screen.',
        'Intelligent Spatial Gridding: We implemented a spatial grid system so the engine only calculates collisions for balls that are near each other.',
        'High Refresh Rate Support: The simulation now natively supports 120Hz and 144Hz monitors for ultra-smooth motion.',
        'Mobile Optimization: Massive battery and heat reductions for creators using the studio on tablets and laptops.'
      ]
    },
    {
      type: 'heading',
      content: 'Optimization Settings Panel'
    },
    {
      type: 'text',
      content: 'We didn\'t just hide these improvements; we gave you control over them. The new Optimization Settings section allows you to toggle "Sub-stepping" (calculating physics multiple times per frame for higher accuracy) and adjust the "Ball Pool" size to match your device\'s power.'
    },
    {
      type: 'highlight',
      content: '"Performance is a feature. A simulation isn\'t satisfying if it stutters, and our migration to Web Workers ensures that every bounce is perfectly fluid, every single time."'
    },
    {
      type: 'heading',
      content: 'Stability Milestone'
    },
    {
      type: 'text',
      content: 'This update significantly reduced "tunneling"—a common physics bug where fast-moving balls might pass through walls. By calculating collisions in the shadow thread at much higher frequencies, the world of Fun Circle Games is now more solid and reliable than ever.'
    }
  ]
};
